import { useEffect } from 'react'
import { create } from 'zustand'

/**
 * How many "couldn't load" cards are on screen right now because the device
 * is offline.
 *
 * The shell's offline banner used to say "Showing what was loaded at 9:07 PM"
 * while the page under it said "You're offline · Couldn't load your profile"
 * with nothing shown: two messages that contradicted each other (UX-018).
 * Every offline error card registers here while it is mounted, so the banner
 * can say what is actually true for this screen.
 */
interface LoadGapState {
  offlineGaps: number
  add: () => void
  remove: () => void
}

export const useLoadGapStore = create<LoadGapState>((set) => ({
  offlineGaps: 0,
  add: () => set((s) => ({ offlineGaps: s.offlineGaps + 1 })),
  remove: () => set((s) => ({ offlineGaps: Math.max(0, s.offlineGaps - 1) })),
}))

/** Register an offline "couldn't load" card for as long as it is mounted. */
export function useRegisterOfflineGap(active: boolean): void {
  useEffect(() => {
    if (!active) return
    const { add, remove } = useLoadGapStore.getState()
    add()
    return remove
  }, [active])
}
